import axios from "@/libs/api.request";

export const login = ({ identity, phone, code, type }) => {
    let data = {
        phone,
        code,
        type,
        token: phone
    };
    let url = "api/passport/loginByToken";
    if (identity === "gonghui") {
        url = "front/v1/common/mockLogin";
        data = {
            username: phone,
            password: code,
            login_type: "username-password"
        };
    }else if(type === 'phone_password'){
        url = "front/v1/common/mockLogin";
        data = {
            username: phone,
            password: code,
            login_type: "phone-password",
        }
    }
    return axios.request({
        url: url,
        data,
        method: "post"
    });
};
export const getUserInfo = token => {
    return axios.request({
        url: "front/v1/user/info",
        method: "get"
    });
};

export const logout = token => {
    return axios.request({
        url: "api/passport/logout",
        method: "post"
    });
};

export const getUnreadCount = () => {
    return axios.request({
        url: "message/count",
        method: "get"
    });
};

export const getMessage = () => {
    return axios.request({
        url: "message/init",
        method: "get"
    });
};

export const getContentByMsgId = msg_id => {
    return axios.request({
        url: "message/content",
        method: "get",
        params: {
            msg_id
        }
    });
};

export const hasRead = msg_id => {
    return axios.request({
        url: "message/has_read",
        method: "post",
        data: {
            msg_id
        }
    });
};

export const removeReaded = msg_id => {
    return axios.request({
        url: "message/remove_readed",
        method: "post",
        data: {
            msg_id
        }
    });
};

export const restoreTrash = msg_id => {
    return axios.request({
        url: "message/restore",
        method: "post",
        data: {
            msg_id
        }
    });
};